import { GameStats } from "./profileLoader";

export const getMainHero = (heroStats : {[hero: string]: GameStats}) => {
    if(!heroStats) return null;
    const sortedHeroes = sortByWinAndLoss(heroStats);
    return sortedHeroes.length > 0 ? sortedHeroes[0] : null;
}

export const sortByWinAndLoss = (table : { [key: string]: { win_count: number; lose_count: number }}) => {
    return Object.entries(table).sort((a, b) => {
        if (b[1].win_count !== a[1].win_count) {
          return b[1].win_count - a[1].win_count;
        }
        return a[1].lose_count - b[1].lose_count;
    });
}

export const formatWinRate = (win_count : number, lose_count : number) : string=> {
    const rate = win_count / (win_count + lose_count);
    return Number(rate * 100).toFixed(0) + "%" || "0%";
}